import type { AllegroReturnPolicy } from '../../../api/allegro/returnpolicy/returnPolicyTypes';
import type { ExcelRow } from '../../excel/types';
import { serializeExcel } from '../../excel/serializeExcel';
import { XLSX_MIME_TYPE } from '../../excel/constants';
import { downloadData } from '../../../utils/downloadData';
import COLUMNS from './returnPolicyExcelSchema';

const SHEET_NAME = 'Return policies';
const DEFAULT_FILE_NAME = 'return-policies.xlsx';

function mapExcelRow(returnPolicy: AllegroReturnPolicy): ExcelRow {
  const {
    availability,
    returnCost,
    address,
    contact,
    options,
  } = returnPolicy;
  const { restrictionCause } = availability;

  return {
    [COLUMNS.id]: returnPolicy.id,
    [COLUMNS.label]: returnPolicy.name,
    [COLUMNS.range]: availability.range,
    [COLUMNS.restrictionCauseName]: restrictionCause?.name ?? undefined,
    [COLUMNS.restrictionCauseDescription]: restrictionCause?.description ?? undefined,
    [COLUMNS.withdrawalPeriod]: returnPolicy.withdrawalPeriod ?? undefined,
    [COLUMNS.coveredBy]: returnCost?.coveredBy ?? undefined,
    [COLUMNS.name]: address?.name ?? undefined,
    [COLUMNS.street]: address?.street ?? undefined,
    [COLUMNS.postCode]: address?.postCode ?? undefined,
    [COLUMNS.city]: address?.city ?? undefined,
    [COLUMNS.countryCode]: address?.countryCode ?? undefined,
    [COLUMNS.email]: contact?.email ?? undefined,
    [COLUMNS.phoneNumber]: contact?.phoneNumber ?? undefined,
    [COLUMNS.cashOnDeliveryNotAllowed]: options?.cashOnDeliveryNotAllowed ?? false,
    [COLUMNS.freeAccessoriesReturnRequired]: options?.freeAccessoriesReturnRequired ?? false,
    [COLUMNS.refundLoweredByReceivedDiscount]: options?.refundLoweredByReceivedDiscount ?? false,
    [COLUMNS.businessReturnAllowed]: options?.businessReturnAllowed ?? false,
    [COLUMNS.collectBySellerOnly]: options?.collectBySellerOnly ?? false,
  };
}

export default async function downloadReturnPoliciesExcel(
  returnPolicies: AllegroReturnPolicy[],
  fileName: string = DEFAULT_FILE_NAME,
): Promise<void> {
  const rows = returnPolicies.map(mapExcelRow);
  const blob = await serializeExcel(rows, {
    sheetName: SHEET_NAME,
    headers: Object.values(COLUMNS),
  });

  downloadData(blob, XLSX_MIME_TYPE, fileName);
}
